// 11. 10. 2026 (owner, docs/thepit.md): The Pit, the arena at Calder Steelworks. Short and plain, like the rest of the game.
export default {
  title: 'The Pit',
  sub: 'Fight nights at the Steelworks, run by the Foundry. You fight a saved survivor, not a live player. You lose no gear here.',
  locked: { title: 'The Pit', body: 'Opens at level {lv}.' },
  join: {
    title: 'Sign up for the Pit',
    body: 'Only those signed up attack and get attacked. Your rating starts at {start}. You can leave any time; back in {h} hours after.',
    button: 'Sign up',
    wait: 'You can sign up on {date}.',
  },
  rank: {
    rating: 'Rating',
    place: '#{place} this week',
    unranked: 'Not ranked this week',
    record: 'Attacks {w}–{l} · Defenses {dw}–{dl}',
    attacks: 'Attacks today: {used} of {max}',
    nextFree: 'Next one free',
    nextEnergy: 'Next one costs {n} energy',
    none: 'No attacks left today',
  },
  offers: {
    title: 'Pick an opponent',
    empty: 'Nobody in your league to fight right now. Check back later.',
    refresh: 'New opponents',
    refreshIn: 'New opponents in {t}',
    kind: { weaker: 'A bit weaker', similar: 'About the same', stronger: 'A bit stronger' },
    win: 'Win: {gain} rating',
    lose: 'Lose: {loss}',
    reward: 'Pays {r}',
    scout: 'Scout',
    fight: 'Fight',
    power: 'Power {n}',
    rating: 'Rating {n}',
  },
  /** 11. 10. 2026 (owner's decision): the Foundry's own fighters, where the league has too few survivors. */
  foundry: {
    tag: 'Foundry fighter',
    scout: 'A Foundry fighter: the Foundry sends one in when your league has too few survivors to fight. A win pays half the reward and half the rating.',
    defenses: 'It never defends.',
  },
  scout: {
    title: 'Scouting: {name}',
    gear: 'Gear for the Pit',
    tree: 'Skill tree',
    noBuild: 'No build yet',
    keystone: 'Keystone: {name}',
    notables: 'Notables: {list}',
    defenses: 'Last defenses',
    noDefenses: 'Not attacked yet.',
    won: 'Held',
    lost: 'Fell',
    hidden: 'style unknown',
    off: 'These do nothing in the Pit: {list}.',
  },
  style: {
    title: 'Pick your style',
    sub: 'Aggressive beats Balanced, Balanced beats Defensive, Defensive beats Aggressive. The style that beats the other deals +{pct}% damage in that fight.',
    seen: 'Their last styles: {list}',
    noneSeen: 'You have not seen their style yet.',
    go: 'Fight as {style}',
    defense: 'Your defense style',
    defenseSub: 'Others fight your saved survivor in this style. Change it any time.',
    beats: 'Beats {s}',
  },
  gear: {
    title: 'Your gear for the Pit',
    sub: 'Its own set, from any of your items. The same item can be worn out there too. An item you lose or dismantle leaves it.',
    worn: 'Same as worn',
    change: 'Change',
    empty: 'Empty',
    remove: 'Take off',
    pick: 'Pick for {slot}',
    none: 'Nothing for this slot.',
    power: 'Power in the Pit {n}',
    off: 'Does nothing in the Pit: {list}',
  },
  history: {
    title: 'Your fights',
    empty: 'No fights yet.',
    attack: 'You attacked {name}',
    defense: '{name} attacked you',
    won: 'Won',
    lost: 'Lost',
    watch: 'Watch',
    new: 'New',
    edgeMe: 'Your style had the edge',
    edgeOpp: 'Their style had the edge',
  },
  week: {
    title: 'This week: {league}',
    ends: 'Ends in {t}',
    need: 'Attack {n} more times this week to be ranked.',
    ranked: '{n} ranked',
    cut: { top10: 'Top {p}%: {chest} and {n} Relic Shards', top25: 'Top {p}%: {chest}', top50: 'Top {p}%: {chest}' },
    you: 'You',
    unranked: 'Not ranked yet',
    last: 'Last week: #{place} of {of} in the {league}',
    lastChest: 'Last week: #{place} of {of} in the {league}. {chest} went to your Storage.',
  },
  rules: {
    title: 'Rules of the Pit',
    lines: {
      saved: 'You fight the saved survivor of another player: their gear for the Pit, skill tree and defense style as they are now.',
      fight: 'No ambush and no escape. The fight goes until someone drops, or {rounds} rounds; then the one with the bigger share of HP left wins.',
      consumables: 'No consumables: no Medkits, meals, Molotovs or Ammo. Firearms shoot at full strength anyway.',
      perks: 'Perks for ambushes and expeditions do nothing here. Fight perks work as out there.',
      loss: 'You lose no gear and no durability.',
      attacks: '{attacks} attacks a day: {free} free, {extra} more for {energy} energy each. Defenses have no limit.',
      rating: 'A rating like chess: it starts at {start} and moves for both sides. Leagues by level: {leagues}.',
      rewards: 'A win pays Scrap and materials for your level. A defense you win pays a little Scrap, with the morning summary.',
      foundry: "If your league has too few survivors to fight, the Foundry sends in its own fighters: a win against one pays half the reward and half the rating, and counts for your attacks this week, but never for the league table or the season's titles.",
      week: 'Every week the top {top10}% of your league get a chest with {shards} Relic Shards, the top {top25}% and {top50}% a smaller chest.',
      season: 'At the end of the season the first of each league becomes Pit Champion. The top {top} get a frame and a banner, the top {outfit}% the Foundry outfit. Then ratings start over.',
      fair: 'Fair play: your account needs {days} days. Survivors on one network never fight each other. Two survivors fight at most {pair} times in a day.',
    },
  },
  leave: { button: 'Leave the Pit', confirm: 'Leave the Pit? You can sign up again in {h} hours. Your rating stays.', yes: 'Leave', no: 'Stay' },
  replay: {
    title: '{a} vs {b}',
    speed: 'Speed',
    skip: 'Skip',
    round: 'Round {n}',
    opening: 'Opening shots',
    hit: '{who} hits for {dmg}',
    crit: '{who} crits for {dmg}',
    miss: '{who} misses',
    stunned: '{who} is stunned',
    blocked: "{who}'s hit is blocked",
    burn: '{who} burns for {dmg}',
    reflect: 'Spikes hit {who} for {dmg}',
    extra: 'Second hit',
    executed: 'Finished off',
    stun: 'Stunned',
    burnOn: 'On fire',
    won: '{name} wins',
    rating: 'Rating {d}',
    reward: 'Reward: {r}',
    share: 'Share this win',
    close: 'Back to the Pit',
    edge: '{name} has the edge: {style} beats {other}',
    moments: 'Key moments',
    moment: {
      edge: '{name} had the style edge (+{pct}% damage).',
      comeback: '{name} came back from {low}% HP.',
      lastBlow: '{name} won on {hp}% HP.',
      decision: 'Ten rounds: {name} won on HP, {a}% to {b}%.',
      perk: {
        execute: 'A finishing critical hit decided it.',
        burn: 'The burn finished it.',
        reflect: 'Spikes finished it.',
        extra: 'A second hit finished it.',
        stun: 'A stun at the end decided it.',
      },
    },
  },
};
